export enum IssueReviewStatusEnum {
  NOT_SET = 'not-set',
  IN_REVIEW = 'in-review',
  TO_BE_PUBLISHED = 'to-be-published',
  PENDING_ACCEPTANCE = 'pending-acceptance',
  ACCEPTED = 'accepted',
}

export type IssueReviewStatusType = `${IssueReviewStatusEnum}`;
